import axiosClient from "./axiosClient";

export async function getProductAttributes() {
  const response = await axiosClient.get("/ProductAttributes");
  return response.data;
}

export async function getProductAttribute(id) {
  const response = await axiosClient.get(`/ProductAttributes/${id}`);
  return response.data;
}

export async function createProductAttribute(payload) {
  const response = await axiosClient.post("/ProductAttributes", payload);
  return response.data;
}

export async function updateProductAttribute(id, payload) {
  const response = await axiosClient.put(`/ProductAttributes/${id}`, payload);
  return response.data;
}

export async function deleteProductAttribute(id) {
  await axiosClient.delete(`/ProductAttributes/${id}`);
}

export async function createAttributeOption(id, payload) {
  const response = await axiosClient.post(`/ProductAttributes/${id}/options`, payload);
  return response.data;
}

export async function updateAttributeOption(id, optionId, payload) {
  const response = await axiosClient.put(`/ProductAttributes/${id}/options/${optionId}`, payload);
  return response.data;
}

export async function deleteAttributeOption(id, optionId) {
  await axiosClient.delete(`/ProductAttributes/${id}/options/${optionId}`);
}
